<template>
  <div>
      
    <div ref="averageScore" style="height:400px;"></div>

    <div ref="excellent" style="height:400px;"></div>

    <div ref="less" style="height:400px;"></div>

    <div ref="pass" style="height:400px;"></div>


  </div>
</template>

<script>
export default {
  data() {
    return {
        apiPath: "/api/AchievementAnalysis/",
        menus: [],
        modal_loading: false,
        loading: true,

        //条件参数获取考试列表
        AcademicYSList: [],//学年学期
        StudentDYGList: [],//学习阶段
        StudentDYGID: [0, 0, 0],
        yearSession: [0, 0],

        //条件参数获取图表信息
        countClassList: [],
        countSubjectList: [],
        countScoreList: "1,2,3,4",


        //考试列表
        examList: [],

        xData: [],
        yData: [],

        //
        rowData: {},


        chartAverageScore: null,
        chartExcellent: null,
        chartLess: null,
        chartPass: null,

    };
  },
  components: {},
  created: function() {
      
  },
  mounted: function() {
        
        this.getRows();

        window.onresize = function () {
            this.chartAverageScore.resize();
            this.chartExcellent.resize();
            this.chartLess.resize();
            this.chartPass.resize();
        };

  },
  methods: {
        // 获取上一页参数
        getRows: function () {
            let rowData = ''
            if(this.$route.query.rowData){
               rowData = JSON.parse(this.$route.query.rowData)
            }
            
            if (rowData.examId > 0) {
                this.chartLoad(rowData.examId);
            } else {
                this.xy.msgError('未获取到考试信息');
            }

        },

        async addMore () {
          let res1 = await this.xyapi.get(
            this.xyMApi + '/xy/comm/GetSessionNodeList'
          );
            //学年-学期
            this.AcademicYSList = res1.data;

          let res2 = await this.xyapi.get(
            this.xyMApi + '/xy/comm/GetSchoolDistrictNodeList'
          );
            //校区-学届-学习阶段
            this.StudentDYGList = res2.data;
        },

        async getTP () {
          let res = await this.xyapi.get(
            this.$store.state.apiPath + this.apiPath +'GetAnalyseAchievementRInfo', {
                academicYearID: this.yearSession[0],//学年
                academicSessionID: this.yearSession[1],//学期
                schoolDistrictID: this.StudentDYGID[0],//校区
                studentYearID: this.StudentDYGID[1],//学届
                studentGradeID: this.StudentDYGID[2],//学习阶段
            }
          );
            this.examList = res&&res.data.data?res.data.data:[];
        },

        yearSessionChangeFun: function (val) {
            if (val.length === 0) {
                this.yearSession = [0, 0];
            }
            if (val.length === 1) {
                this.yearSession = [val[0], 0];
            }
            if (val.length === 2) {
                this.yearSession = val;
            }
            this.getTP();
        },
        cascaderFun: function (val) {
            if (val.length === 1) {
                this.StudentDYGID = [val[0], 0, 0];
            }
            if (val.length === 2) {
                this.StudentDYGID = [val[0], val[1], 0];
            }
            if (val.length === 3) {
                this.StudentDYGID = val
            }
            this.getTP();
        },


        examChange: function (value) {
            console.log("选择的val" + value)
            
            this.chartLoad(value);
        },

        //将图表置为loading状态...
        chartLoad: function (examId) {
            

            this.chartAverageScore = this.echarts.init(this.$refs.averageScore);
            this.chartAverageScore.showLoading();

            this.chartExcellent = this.echarts.init(this.$refs.excellent);
            this.chartExcellent.showLoading();

            this.chartLess = this.echarts.init(this.$refs.less);
            this.chartLess.showLoading();

            this.chartPass = this.echarts.init(this.$refs.pass);
            this.chartPass.showLoading();


            this.GetAchievementAnalysisData(examId);

        },

        //获取全部数据
        async GetAchievementAnalysisData (examId) {
            console.log("GetAchievementAnalysisData ...")
          let res = await this.xyapi.get(
            this.$store.state.apiPath + this.apiPath +'GetAchievementAnalysisData', {
                id: examId
            }
          );
        if (res.success) {
            console.log(res.data)

            this.AverageScore(res.data[1]);
            this.Excellent(res.data[2]);
            this.Pass(res.data[3]);
            this.Less(res.data[4]);


        } else {
            this.xy.msgError(res.msg);
            // MainVue.$Modal.error({ title: "错误信息", content: res.data.msg });
        }


        },

        //平均分--柱状图
        AverageScore: function (data) {
            

            let xAxisDataList = [];
            let seriesDataList = [];
            data.forEach((item)=>{
                xAxisDataList.push(item.Name);
                seriesDataList.push(item.value);
            })
            let option = {
                title: {
                    text: '平均分',
                    subtext: '',
                    x: 'center'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [{
                    type: 'category',
                    data: xAxisDataList,
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLabel: {
                        interval: 0,
                        formatter: function (value) {
                            return this.formatterEllipsis(value);
                        }
                    },
                },

                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '平均分',
                        type: 'bar',
                        barWidth: '60%',
                        data: seriesDataList
                    }
                ]
            };

            this.chartAverageScore.hideLoading();
            this.chartAverageScore.setOption(option, true);

        },

        //优秀率--柱状图
        Excellent: function (data) {
            

            let xAxisDataList = [];
            let seriesDataList = [];
            data.forEach((item)=>{
                xAxisDataList.push(item.Name);
                seriesDataList.push(item.value);
            })
            let option = {
                title: {
                    text: '优秀率',
                    subtext: '',
                    x: 'center'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: xAxisDataList,
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLabel: {
                            interval: 0,
                            formatter: function (value) {
                                return this.formatterEllipsis(value);
                            }
                        },
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '优秀率',
                        type: 'bar',
                        barWidth: '60%',
                        data: seriesDataList
                    }
                ]
            };
            // 使用刚指定的配置项和数据显示图表。
            this.chartExcellent.hideLoading();
            this.chartExcellent.setOption(option, true);

        },


        //低分率--柱状图
        Less: function (data) {
            

            let xAxisDataList = [];
            let seriesDataList = [];
            data.forEach((item)=>{
                xAxisDataList.push(item.Name);
                seriesDataList.push(item.value);
            })
            let option = {
                title: {
                    text: '低分率',
                    subtext: '',
                    x: 'center'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: xAxisDataList,
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLabel: {
                            interval: 0,
                            formatter: function (value) {
                                return this.formatterEllipsis(value);
                            }
                        },
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '低分率',
                        type: 'bar',
                        barWidth: '60%',
                        data: seriesDataList
                    }
                ]
            };

            this.chartLess.hideLoading();
            this.chartLess.setOption(option, true);

        },


        //及格率--柱状图
        Pass: function (data) {
            

            let xAxisDataList = [];
            let seriesDataList = [];

            data.forEach((item)=>{
                xAxisDataList.push(item.Name);
                seriesDataList.push(item.value);
            })
            let option = {
                title: {
                    text: '及格率',
                    subtext: '',
                    x: 'center'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        data: xAxisDataList,
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLabel: {
                            interval: 0,
                            formatter: function (value) {
                                return this.formatterEllipsis(value);
                            }
                        },
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '及格率',
                        type: 'bar',
                        barWidth: '60%',
                        data: seriesDataList
                    }
                ]
            };

            this.chartPass.hideLoading();
            this.chartPass.setOption(option, true);

        },
        formatterEllipsis: function () {
            var value = "";
            var maxLength = 3;//每项显示文字个数
            if (arguments.length === 1) {
                value = arguments[0];
            } else if (arguments.length === 2) {
                value = arguments[0];
                maxLength = arguments[1];
            } else {
                return "";
            }

            var valLength = value.length;//X轴类目项的文字个数
            var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
            if (rowN > 1)//如果类目项的文字大于3,
            {
                return value.substring(0, maxLength) + "...";
            }
            else {
                return value;
            }
        },
  }
};
</script>
<style lang='less' >

</style>

